import {ApiException} from "@/domain/core/exception/exceptions";
import {emptyListResponse} from "@/domain/core/utils/django";

const state = {
    tagDefinitions: {...emptyListResponse},
    currentTag: null,
    loading: false,
}

export const getters = {
    tagDefinitions: state => state.tagDefinitions,
    allTags: state => state.tagDefinitions.results || [],
    systemTags: state => (state.tagDefinitions.results || []).filter(t => t.is_implicit),
    serviceTags: state => (state.tagDefinitions.results || []).filter(t => !t.is_implicit),
    currentTag: state => state.currentTag,
    loading: state => state.loading,
}

export const mutations = {
    setTagDefinitions(state, data) {
        state.tagDefinitions = data
    },
    setCurrentTag(state, tag) {
        state.currentTag = tag
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    updateTag(state, updatedTag) {
        const index = state.tagDefinitions.results.findIndex(t => t.id === updatedTag.id)
        if (index !== -1) {
            state.tagDefinitions.results.splice(index, 1, updatedTag)
        }
    },
    addTag(state, tag) {
        state.tagDefinitions.results.push(tag)
    },
    removeTag(state, id) {
        state.tagDefinitions.results = state.tagDefinitions.results.filter(t => t.id !== id)
    },
    clearCurrentTag(state) {
        state.currentTag = null
    }
}

export const actions = tagDefinitionsService => ({
    async fetchTagDefinitions({commit}, {picaServiceId, filters, pagination, sorting}) {
        try {
            const data = await tagDefinitionsService.fetchTagDefinitions(picaServiceId, filters, pagination, sorting)
            commit('setTagDefinitions', data)
        } catch (e) {
            if (e instanceof ApiException) {
                commit('setTagDefinitions', emptyListResponse)
            }
            throw e
        }
    },

    async fetchTagDefinition({commit}, {picaServiceId, id}) {
        commit('setLoading', true)
        try {
            const tag = await tagDefinitionsService.fetchTagDefinition(picaServiceId, id)
            commit('setCurrentTag', tag)
            return tag
        } catch (e) {
            throw e
        } finally {
            commit('setLoading', false)
        }
    },

    async createTagDefinition({commit}, {picaServiceId, data}) {
        const tag = await tagDefinitionsService.createTagDefinition(picaServiceId, data)
        commit('addTag', tag)
        return tag
    },

    async updateTagDefinition({commit}, {picaServiceId, id, data}) {
        const tag = await tagDefinitionsService.updateTagDefinition(picaServiceId, id, data)
        commit('updateTag', tag)
        return tag
    },

    async deleteTagDefinition({commit}, {picaServiceId, id}) {
        await tagDefinitionsService.deleteTagDefinition(picaServiceId, id)
        commit('removeTag', id)
    },

    clearCurrentTag({commit}) {
        commit('clearCurrentTag')
    }
})

export default tagDefinitionsService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(tagDefinitionsService)
})
